<template>
	<div class="login-wrap">
		<!-- <van-icon class="back" @click="back" name="arrow-left" size="24"></van-icon> -->
		<div class="login-title">手机号登录/注册</div>
		<div class="input-wrap">
			<van-field class="input" v-model="tel" type="tel" placeholder="请输入你的手机号码">
				<template slot="label">
					<div class="dict">
						<span>+86</span>
						<van-icon name="arrow-down"></van-icon>
					</div>
				</template>
			</van-field>
		</div>
		<div class="login-button" >
			<van-button type="info" :disabled="!validated" @click="toVerify" block>下一步</van-button>
		</div>
		<div class="login-methods">
			<span @click="toAccoutLogin">账号密码登录</span>
		</div>
		<div class="bottom">
			<div class="provider">
				<span>微信登录</span>
				<img src="../assets/images/wx.png" @click="wxLogin" alt="">
			</div>
			<div class="protocal">
				阅读<span class="detail">《用户协议与隐私政策》</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant'
	export default {
		name: 'Login',
		data() {
			return {
				tel: '',
				validated: false
			}
		},
		watch: {
			tel(val) {
				let reg = /^1[3-9]\d{9}$/
				if (reg.test(val)) {
					this.validated = true
				} else {
					this.validated = false
				}
			}
		},
		methods: {
			toAccoutLogin ( ) {
				this.$router.push('accountlogin')
			},
			toVerify () {
				Toast.loading({
					message: '正在发送',
					duration: 0
				})
				this.$api.post('SendSms', {
					phone: this.tel
				}).then(res => {
					Toast.clear()
					if (res.resultCode =='0') {
						this.$router.push({
							path: 'verify',
							query: {
								phone: this.tel
							}
						})
					} else {
						Toast('信息发送失败，请重试')
					}
				})
			},
			back() {
				this.$router.goBack()
			},
			wxLogin() {
				Toast('暂未开放')
				// uni.reLaunch({
				// 	url: '../login/login'
				// })
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-wrap {
		font-size: 16px;
		.back {
			margin: 20px;
		}
	}
	.input-wrap {
		margin: 24px;
		border-bottom: 1px solid #f1f1f1;
		padding: 6px 0;
		.van-field__label{
			width: 50px;
			color: #666666;
		}
		.input {
			padding: 6px 0;
		}
	}
	.login-title {
		font-size: 24px;
		margin: 20px;
		margin-top: 60px;
	}
	.dict {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.login-button {
		margin: 0 24px;
		.van-button--disabled {
			opacity: 1;
			border: 1px solid #acacac;
			background-color: #acacac;
		}
	}
	
	.login-methods {
		padding: 10px 24px;
		font-size: 12px;
		color: #6a6a6a;
	}
	.bottom {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 120px;
		.provider {
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #6a6a6a;
			img {
				width: 50px;
				height: 50px;
				margin-top: 4px;
			}
		}
		.protocal {
			margin-top: 10px;
			display: flex;
			justify-content: center;
			font-size: 12px;
			color: #6a6a6a;
			.detail {
				margin-left: 2px;
				color: #1989fa;
				font-size: 12px;
			}
		}
	}
</style>
